module.exports = __webpack_public_path__ + "static/images/banner-new.557ca8e.png";